// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CartLineContext } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import CartLineCardCondensed, {
    CartLineCardCondensedStyles,
} from "@insite/content-library/Components/CartLineCardCondensed";
/* Store Custom Code
import CartLineCardExpanded, {
    CartLineCardExpandedStyles,
} from "@insite/content-library/Components/CartLineCardExpanded";
*/
import CartLinesListHeader, { CartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import CartLineCardExpanded, { CartLineCardExpandedStyles } from "@store/Overrides/Components/CartLineCardExpanded";
/* Store Custom Code - End */

interface OwnProps {
    cart: Cart;
    promotions?: PromotionModel[];
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent<Element, Event>, value: boolean) => void;
    editable: boolean;
    showSavingsAmount: boolean;
    showSavingsPercent: boolean;
    extendedStyles?: CartLinesListStyles;
    // Starter Custom Code
    overridedStyles?: CartLinesListStyles;
    // Store Custom Code
    isLineNotesOpen?: boolean;
    showLineNumber?: boolean;
    hasSplitOrders?: boolean;
    orderLineNotesMaxLength?: number;
}

export interface CartLinesListStyles {
    wrapper?: InjectableCss;
    header?: CartLinesListHeaderStyles;
    cardCondensed?: CartLineCardCondensedStyles;
    cardExpanded?: CartLineCardExpandedStyles;
    pagination?: PaginationPresentationProps;
    // Starter Custom Code
    listWrapper?: InjectableCss;
}

export const orderLinesListStyles: CartLinesListStyles = {
    /* Store Custom Code - Start */
    pagination: {
        cssOverrides: {
            pagination: css`
                @media print {
                    display: none;
                }
            `,
        },
    },
    /* Store Custom Code - End */
};

const CartLinesList: FC<OwnProps> = ({
    cart,
    promotions,
    isCondensed,
    hideCondensedSelector,
    onChangeIsCondensed,
    editable,
    showSavingsAmount,
    showSavingsPercent,
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    // Store Custom Code
    isLineNotesOpen,
    showLineNumber,
    hasSplitOrders,
    orderLineNotesMaxLength,
}) => {
    const styles = useExpandProps(orderLinesListStyles, extendedStyles, overridedStyles); // Starter Custom Code

    if (!cart.cartLines) {
        return null;
    }

    /* Starter Custom Code - Start */
    isCondensed = false;
    hideCondensedSelector = true;
    /* Starter Custom Code - End */

    const cartLines =
        cart.status === "Cart" ? cart.cartLines.filter(cartline => !cartline.quoteRequired) : cart.cartLines;

    const CartLineComponent = isCondensed ? CartLineCardCondensed : CartLineCardExpanded;

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`cardLinesList_${cart.id}`}>
            {/* Store Removed - CartLinesListHeader */}
            <StyledWrapper {...styles.listWrapper} /* Starter Custom Code */>
                {cartLines!.map((cartLine, index /* Store Custom Code */) => {
                    const cartLinePromotions = promotions?.filter(promotion => promotion.orderLineId === cartLine.id);
                    return (
                        <CartLineContext.Provider value={cartLine} key={cartLine.id}>
                            <CartLineComponent
                                cart={cart}
                                promotions={cartLinePromotions}
                                editable={editable}
                                showSavingsAmount={showSavingsAmount}
                                showSavingsPercent={showSavingsPercent}
                                showInvalidPriceMessage={true}
                                extendedStyles={isCondensed ? styles.cardCondensed : styles.cardExpanded}
                                // Store Custom Code
                                isLineNotesOpen={isLineNotesOpen}
                                showLineNumber={showLineNumber}
                                index={index}
                                hasSplitOrders={hasSplitOrders}
                                orderLineNotesMaxLength={orderLineNotesMaxLength}
                            />
                        </CartLineContext.Provider>
                    );
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default CartLinesList;
